import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bdb0e5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6bdb0e5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb0e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/linyuqiu/IdeaProjects/huoquan/ningde-huoquan-supplier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdb0e5a')) {
      api.createRecord('6bdb0e5a', component.options)
    } else {
      api.reload('6bdb0e5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bdb0e5a&scoped=true", function () {
      api.rerender('6bdb0e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/footer/index.vue"
export default component.exports